function OnGoingWmsStepFive({ configuration }) {
    return (
        <div>
            <h3 className="text-2xl font-semibold mb-8">
                Steg 5 -{" "}
                <span className="text-lg font-medium text-accent">
                    Bekräfta och Slutför
                </span>
            </h3>

            <div className="flex flex-row justify-between items-start space-x-8">
                <div className="w-3/5 flex flex-col space-y-8">
                    <ul className="text-md font-medium list-disc list-outside pl-6 space-y-4">
                        <li>
                            Granska dina inställningar nedan. Om du är nöjd med
                            dina val, klicka på "Slutför" för att bekräfta och
                            spara integrationen.
                        </li>
                    </ul>

                    <div className="flex flex-col space-y-4">
                        <div>
                            <label className="block font-medium">
                                API Användarnamn
                            </label>
                            <p className="p-2 h-10 rounded-md bg-gray-100">
                                {configuration.username}
                            </p>
                        </div>
                        <div>
                            <label className="block font-medium">
                                Warehouse
                            </label>
                            <p className="p-2 h-10 rounded-md bg-gray-100">
                                {configuration.identifier}
                            </p>
                        </div>
                        <div>
                            <label className="block font-medium">
                                Valt API
                            </label>
                            <p className="p-2 h-10 rounded-md bg-gray-100">
                                {configuration.selectedApi === "godsagare"
                                    ? "API för godsägare"
                                    : "API för automation"}
                            </p>
                        </div>
                        <div>
                            <label className="block font-medium">
                                Upphämtningsadress
                            </label>
                            <p className="p-2 h-10 rounded-md bg-gray-100">
                                {configuration.pickupAddress}
                            </p>
                        </div>
                        <div>
                            <label className="block font-medium">
                                Inkludera Order-ID i Referens Fältet
                            </label>
                            <p className="p-2 h-10 rounded-md bg-gray-100">
                                {configuration.includeOrderIdInReference ===
                                "Ja"
                                    ? "Ja"
                                    : "Nej"}
                            </p>
                        </div>
                        <div>
                            <label className="block font-medium">
                                Kollidimensioner
                            </label>
                            <p className="p-2 h-10 rounded-md bg-gray-100">
                                {configuration.selectGoodsSource ===
                                "Fraktsedelsrader"
                                    ? "Fraktsedelsrader"
                                    : "Orderrader"}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OnGoingWmsStepFive;
